const SITE_URL = "https://www.wags.com";

export const LISTING_SITEMAP_PAGE_SIZE = 10_000;

export const STATIC_SITEMAP_PATHS = [
    "/",
    "/find",
    "/about",
    "/filter-quiz",
    "/faq",
    "/ethos",
    "/values",
    "/privacy",
    "/terms",
] as const;

function escapeXml(value: string): string {
    return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");
}

export function sitemapResponse(xml: string): Response {
    return new Response(xml, {
        headers: {
            "Content-Type": "application/xml; charset=utf-8",
            "Cache-Control":
                "public, max-age=300, s-maxage=3600, stale-while-revalidate=86400",
        },
    });
}

export function buildSitemapIndex(listingPageCount: number): string {
    const sitemapUrls = [
        `${SITE_URL}/sitemaps/static.xml`,
        ...Array.from(
            { length: listingPageCount },
            (_, index) => `${SITE_URL}/sitemaps/dogs-${String(index + 1)}.xml`,
        ),
    ];

    return `<?xml version="1.0" encoding="UTF-8"?>
<sitemapindex xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${sitemapUrls.map((url) => `  <sitemap><loc>${escapeXml(url)}</loc></sitemap>`).join("\n")}
</sitemapindex>`;
}

export function buildUrlSet(
    entries: Array<{ path: string; lastModified?: Date }>,
): string {
    return `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${entries
    .map(({ path, lastModified }) => {
        const location = escapeXml(`${SITE_URL}${path}`);
        const lastmod = lastModified
            ? `<lastmod>${lastModified.toISOString()}</lastmod>`
            : "";
        return `  <url><loc>${location}</loc>${lastmod}</url>`;
    })
    .join("\n")}
</urlset>`;
}
